// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"083a8f45","454":"9561fc4c","875":"b37fad64"}[chunkId] + ".chunk.js";
};